const state = {
  items: [],
  sessionID: "",
  voucher: null,
  special_requirements: "",
  delivery_type: "Delivery"
}

const getters = {
  subTotal: state => state.items.reduce((total, item) => total + item.price * item.qty, 0),
  includesGates: (state, getters, rootState) => {
    if (!state.items.length) return false    
    var gates = state.items.filter(i => i.product_type == "gate" && !i.delivery)
    if (gates.length) {
      return true
    } else {
      return false
    }
  },
  delivery: (state, getters, rootState) => {
    if (!state.items.length) return 0

    if (state.delivery_type == "Delivery") {
      // if still waiting for misc page to download, return zero
      if (!rootState.misc) return 0
      var misc = rootState.misc

      var deliveryamounts = []

      // calculate item specific delivery
      var withDelivery = state.items.filter(i => i.delivery)
      withDelivery.forEach(item => deliveryamounts.push(parseFloat(item.delivery)))

      // get delivery values from misc
      var gatesDel = misc.gates_price ? parseFloat(misc.gates_price) : 0
      var postsDel = misc.posts_price ? parseFloat(misc.posts_price) : 0
      var ironDel = misc.irongmongery_price ? parseFloat(misc.irongmongery_price) : 0
      var treatmentsDel = misc.treatments_price ? parseFloat(misc.treatments_price) : 0

      // get specific extra types
      var gates = state.items.filter(i => i.product_type == "gate" && !i.delivery)
      var posts = state.items.filter(i => i.product_type == "post" && !i.delivery)
      var iron = state.items.filter(i => i.product_type == "ironmongery" && !i.delivery)
      var treatments = state.items.filter(i => i.product_type == "treatment" && !i.delivery)

      if (gates.length) deliveryamounts.push(gatesDel)
      if (posts.length) deliveryamounts.push(postsDel)
      if (iron.length) deliveryamounts.push(ironDel)
      if (treatments.length) deliveryamounts.push(treatmentsDel)

      return Math.max.apply(null, deliveryamounts)
    }

    if (state.delivery_type == "Collection") return 0
  },
  vat: (state, getters) => (getters.subTotal + getters.delivery) * 0.2,
  voucher_discount: (state, getters) => {
    if (getters.subTotal == 0) return 0
    if (!state.voucher) return 0

    switch (state.voucher.type) {
      case "Percentage":
        return (getters.subTotal + getters.vat) * (state.voucher.value / 100)
      case "Fixed":
        return state.voucher.value
      default:
        return 0
    }
  },
  delivery_discount: (state, getters, rootState) => {
    if (getters.subTotal == 0) return 0
    if (state.delivery_type != "Delivery") return 0
    if (!rootState.misc) return 0
    var misc = rootState.misc

    if (misc.delivery_offer_enabled && misc.delivery_offer_discount && misc.delivery_offer_type) {
      if (misc.delivery_offer_type == "Flat" && misc.delivery_offer_discount <= getters.delivery)
        return misc.delivery_offer_discount
      if (misc.delivery_offer_type == "Percentage") return getters.delivery * (misc.delivery_offer_discount / 100)
    }

    return 0
  },
  collection_discount: (state, getters, rootState) => {
    if (getters.subTotal == 0) return 0
    if (state.delivery_type != "Collection") return 0
    if (!rootState.misc) return 0
    var misc = rootState.misc

    if (misc.collection_offer_enabled && misc.collection_offer_discount && misc.collection_offer_type) {
      if (misc.collection_offer_type == "Flat" && misc.collection_offer_discount <= getters.subTotal)
        return misc.collection_offer_discount
      if (misc.collection_offer_type == "Percentage") return getters.subTotal * (misc.collection_offer_discount / 100)
    }

    return 0
  },
  grandTotal: (state, getters) =>
    getters.subTotal +
    getters.delivery +
    getters.vat -
    getters.voucher_discount -
    getters.delivery_discount -
    getters.collection_discount
}

const mutations = {
  addItem: (state, payload) => state.items.push(payload),
  applyVoucher: (state, payload) => (state.voucher = payload),
  updateQty: (state, payload) => {
    if (payload.quantity > 0) state.items[payload.index].qty = Number(payload.quantity)
    else state.items.splice(payload.index, 1)
  },
  emptyCart: state => (state.items = []),
  special: (state, payload) => (state.special_requirements = payload),
  delivery_type: (state, payload) => (state.delivery_type = payload)
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
